import { render, staticRenderFns } from "./IntegrationReportTableItem.vue?vue&type=template&id=1fe54523&scoped=true"
import script from "./IntegrationReportTableItem.vue?vue&type=script&lang=js"
export * from "./IntegrationReportTableItem.vue?vue&type=script&lang=js"
import style0 from "./IntegrationReportTableItem.vue?vue&type=style&index=0&id=1fe54523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe54523",
  null
  
)

export default component.exports